import { connect } from 'react-redux';
import * as actions from './BalanceSheetActions';
import ProjectedBalanceSheetView from './BalanceSheetView';

const mapStateToProps = (state, ownProps) => {
  let subdivision = state.BalanceSheet[ownProps.clientId];
  return {
    clientId: ownProps.clientId,
    is_initialized: subdivision ? subdivision.is_initialized : false,
    ProjectedItems: subdivision ? subdivision.ProjectedItems : null,
    errors: subdivision ? subdivision.errors : null,
    is_current: subdivision ? subdivision.is_current : ownProps.is_current,
    year: subdivision
      ? subdivision.year
      : `'${moment().format('YY')}-'${moment()
          .add(1, 'years')
          .format('YY')}`,
    PrincipalAgeOptions: subdivision ? subdivision.PrincipalAgeOptions : [],
    SpouseAgeOptions: subdivision ? subdivision.SpouseAgeOptions : [],
    PrincipalName: subdivision ? subdivision.PrincipalName : [],
    SpouseName: subdivision ? subdivision.SpouseName : [],
    OwnerOptions: subdivision ? subdivision.OwnerOptions : [],
    owners: subdivision ? subdivision.owners : [],
    BalanceSheet: subdivision ? subdivision.BalanceSheet : [],
    isPrint: ownProps.isPrint,
    title: ownProps.title,
  };
};

const mapDispatchToProps = dispatch => ({
  fetch_data(owners, clientId) {
    dispatch(actions.fetch_data(owners, clientId));
  },
  remove_owner(owners, owner, clientId) {
    dispatch(actions.remove_owner(owners, owner, clientId));
  },
  unset_errors(clientId) {
    function return_function1() {
      dispatch(actions.set_errors('', this.clientId));
    }
    return return_function1.bind({ clientId });
  },
});

const BalanceSheet = connect(mapStateToProps, mapDispatchToProps)(ProjectedBalanceSheetView);

export default BalanceSheet;
